var dhtmlxHierarchy = (function () {
    function dhtmlxHierarchy(a) {
        var c = {
            id: 0,
            childs: [],
            level: -1,
            parent: null,
            index: 0,
            state: a._emptyLineImg
        };
        this.order = [c];
        this.get = { "0": c };
        this._emptyLineImg = a._emptyLineImg;
        return this;
    }
    dhtmlxHierarchy.prototype.swap = function (g, e) {
        var h = g.parent;
        var l = g.index;
        h.childs[l] = e;
        h.childs[e.index] = g;
        g.index = e.index;
        e.index = l;
    };
    dhtmlxHierarchy.prototype.forEachChildF = function (n, e, l, g) {
        var m = this.get[n];
        for (var h = 0; h < m.childs.length; h++) {
            if (!e.apply(l || this, [m.childs[h]])) {
                continue;
            }
            if (m.childs[h].childs.length) {
                this.forEachChildF(m.childs[h].id, e, l, g);
            }
            if (g) {
                g.call(l || this, m.childs[h]);
            }
        }
    };
    dhtmlxHierarchy.prototype.forEachChild = function (m, e, h) {
        var l = this.get[m];
        for (var g = 0; g < l.childs.length; g++) {
            e.apply(h || this, [l.childs[g]]);
            if (l.childs[g].childs.length) {
                this.forEachChild(l.childs[g].id, e, h);
            }
        }
    };
    dhtmlxHierarchy.prototype.change = function (l, e, h) {
        var g = this.get[l];
        if (g[e] == h) {
            return;
        }
        g[e] = h;
        g.update = true;
    };
    dhtmlxHierarchy.prototype.add = function (g, e) {
        return this.addAfter(g, e);
    };
    dhtmlxHierarchy.prototype.addAfter = function (r, o, h, g) {
        var n = this.get[o || 0];
        var m = null;
        if (h) {
            m = this.get[h].index + (g ? 0 : 1);
        }
        else {
            m = n.childs.length;
        }
        var e = {
            id: r,
            childs: [],
            level: n.level + 1,
            parent: n,
            index: m,
            state: this._emptyLineImg
        };
        if (n.state == this._emptyLineImg) {
            this.change(o, "state", o == 0 ? "minus" : "plus");
        }
        if (h) {
            for (var l = m; l < n.childs.length; l++) {
                n.childs[l].index++;
            }
            n.childs = n.childs
                .slice(0, m)
                .concat([e])
                .concat(n.childs.slice(m, n.childs.length));
        }
        else {
            n.childs.push(e);
        }
        this.get[r] = e;
        return e;
    };
    dhtmlxHierarchy.prototype.addBefore = function (h, g, e) {
        return this.addAfter(h, g, e, true);
    };
    dhtmlxHierarchy.prototype.remove = function (h) {
        var g = this.get[h || 0];
        for (var e = 0; e < g.childs.length; e++) {
            this.deleteAll(g.childs[e].id);
        }
        g.childs = [];
        g.parent.childs = g.parent.childs
            .slice(0, g.index)
            .concat(g.parent.childs.slice(g.index + 1));
        for (var e_1 = g.index; e_1 < g.parent.childs.length; e_1++) {
            g.parent.childs[e_1].index--;
        }
        delete this.get[h];
    };
    dhtmlxHierarchy.prototype.deleteAll = function (h) {
        var g = this.get[h || 0];
        for (var e = 0; e < g.childs.length; e++) {
            this.deleteAll(g.childs[e].id);
        }
        g.childs = [];
        delete this.get[h];
    };
    return dhtmlxHierarchy;
})();

export default dhtmlxHierarchy;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dXGridObject/dhtmlxHierarchy.js